import {
  type AxiosRequestConfig,
  httpClient,
  type Path,
} from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';

export interface SaveDraftRequestBody {
  service_id: string;
  user_id: string;
  order_time: number;
  path: Path[];
  requests: any[];
  payment_method: string;
  total_pay: number;
  promo_code?: string;
  remarks?: string;
  idle_until?: number;
  suggest_promotion?: boolean;
  inserted_time?: number;
  updated_time?: number;
  type?: string;
}
export const createDraftFn = async (
  body: SaveDraftRequestBody,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.post<SaveDraftRequestBody>(
    apiRoutes.draft.createDraft,
    body,
    config
  );
  return response.data;
};
